import { format } from 'date-fns';

/**
 * POM-6099 — the one timestamp format the relay views use ('N/A' for a missing or unparseable
 * value). Shared by RelayOrderDetailsDialog's summary and RelayEventTimeline so the two cannot
 * drift apart.
 */
const formatRelayDate = (value) => {
  if (!value) return 'N/A';

  try {
    return format(new Date(value), 'MM/dd/yyyy hh:mm a');
  } catch {
    return 'N/A';
  }
};

export default formatRelayDate;
